import type { MeetingViewContext } from '../use-meeting-view-model'

/**
 * The audio session behind a meeting view entry. A `live` entry is the
 * running session while that recording is its meeting: before it names a
 * note, or while the note it names is the one recording. Otherwise it is
 * the session behind the note it named.
 */
export function meetingSessionId({
  context,
  liveSessionId,
  recordingNoteId,
  namedSessionId,
  noteSessionId,
}: {
  context: MeetingViewContext | undefined
  liveSessionId: string | undefined
  recordingNoteId: string | undefined
  /** The session behind the meeting the entry names, as this renderer saw it live. */
  namedSessionId: string | undefined
  /**
   * The session the server records for the named note. A window that never saw
   * the meeting live, like a saved meeting opened later or after a restart, has
   * only this.
   */
  noteSessionId?: string
}): string | undefined {
  const isLive = !context || context.mode === 'live'
  const isRecording = isLive && (!context?.audioNoteId || context.audioNoteId === recordingNoteId)
  if (isRecording && liveSessionId) {
    return liveSessionId
  }
  return namedSessionId ?? noteSessionId
}
